<template>
    <v-col cols="12" v-if="curso">
        <template v-if="curso.imagen_url && moduloIndex === null">
            <v-img :src="curso.imagen_url" max-height="400" cover />
        </template>
        <v-card class="mx-0 mx-sm-4">
            <template v-if="moduloIndex !== null && moduls.modulos[moduloIndex]">
                <v-card-subtitle style="word-break: break-word;" class="mt-4 text-wrap"> {{ curso.titulo }}
                </v-card-subtitle>
                <v-card-actions v-if="selectedOption === 'editar'">
                    <v-btn color="primary" @click="openModuleDialog(moduloIndex)" prepend-icon="mdi-pencil">
                        {{ t('Editar') }}
                    </v-btn>
                    <v-btn color="secondary" prepend-icon="mdi-sort" @click="showSortDialog = true">
                        {{ t('Ordenar') }}
                    </v-btn>
                    <v-btn color="error" @click="confirmDelete(moduloIndex)" prepend-icon="mdi-delete">
                        {{ t('Eliminar') }}
                    </v-btn>
                </v-card-actions>
                <v-card-title style="word-break: break-word;" class="text-h4 text-wrap font-weight-bold my-2">{{
                    moduls.modulos[moduloIndex].titulo }} </v-card-title>
                <v-card-text>
                    <v-alert v-if="!moduls.modulos[moduloIndex].activo">Este módulo todavía no está activo.</v-alert>
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="d-flex align-center justify-center" style="min-width: 200px;">
                            <MarkdownText v-if="moduls.modulos[moduloIndex].activo || selectedOption === 'editar'"
                                :markdownText="moduls.modulos[moduloIndex].descripcion"></MarkdownText>
                        </v-col>
                        <v-col cols="12">
                            <v-card variant="tonal" color="primary" class="mt-4">
                                <v-card-title class="d-flex align-center">
                                    <v-icon class="mr-2">mdi-format-list-numbered</v-icon>
                                    {{ t('Contenido_del_módulo') }}
                                </v-card-title>
                                <v-list v-if="moduls.modulos[moduloIndex].activo" bg-color="transparent">
                                    <v-list-item v-for="(leccion, lI) in moduls.modulos[moduloIndex].lecciones"
                                        :key="leccion.id" @click="$emit('select-leccion', moduloIndex, lI)">
                                        <template #prepend>
                                            <v-avatar color="primary" variant="tonal" size="32" class="mr-3">
                                                {{ lI + 1 }}
                                            </v-avatar>
                                        </template>
                                        <v-list-item-title>
                                            {{ leccion.titulo }}
                                        </v-list-item-title>
                                        <template #append>
                                            <v-icon>mdi-chevron-right</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </template>
            <template v-if="moduloIndex === null">
                <v-card-title style="word-break: break-word;" class="text-h4 text-wrap font-weight-bold my-2">{{
                    curso.titulo }}
                </v-card-title>
                <v-card-text>
                    <MarkdownText :markdownText="curso.presentacion"></MarkdownText>
                </v-card-text>
            </template>
        </v-card>
    </v-col>
    <template v-if="curso && moduloIndex === null">
        <v-col cols="12" v-if="!drawer">
            <v-card class="mx-4">
                <v-card-actions>
                    <v-btn color="primary" @click.stop="openDrawer">
                        {{ t('Índice_de_contenidos') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        <template v-if="selectedOptionVista === 'alumno'">
            <v-col cols="12" md="6">
                <v-card class="mx-4">
                    <v-card-title>{{ t('Tu_progreso') }}</v-card-title>
                    <v-card-text>
                        <div v-if="progresoTeorico.total > 0" class="mb-4">
                            <div class="d-flex justify-space-between mb-2">
                                <span>{{ t('Tests_teóricos_completados') }}</span>
                                <strong>{{ progresoTeorico.porcentaje }}%</strong>
                            </div>
                            <v-progress-linear :model-value="progresoTeorico.porcentaje" color="primary" height="10"
                                rounded />
                            <div class="text-caption mt-2">
                                {{ progresoTeorico.completados }}
                                {{ t('de') }} {{ progresoTeorico.total }} {{ t('tests_realizados') }}
                            </div>
                        </div>
                        <template v-if="curso && curso.porcentaje_teorico > 0 && curso.porcentaje_teorico < 100">
                            <div>
                                {{ t('Puntuación_teórica') }} ({{ curso.porcentaje_teorico }}%) :
                                {{ curso.notas && curso.notas.puntaje_teorico_ponderado !== null ?
                                    curso.notas.puntaje_teorico_ponderado :
                                    t('Pendiente') }}
                                <span v-if="curso.notas && curso.notas.puntaje_teorico !== null">
                                    ({{ curso.notas.puntaje_teorico }} {{ t('puntos') }})
                                </span>
                            </div>
                            <div>
                                {{ t('Puntuación_práctica') }} ({{ 100 - curso.porcentaje_teorico }}%) :
                                {{ curso.notas && curso.notas.puntaje_practico_ponderado !== null ?
                                    curso.notas.puntaje_practico_ponderado : t('Pendiente') }}
                                <span v-if="curso.notas && curso.notas.puntaje_practico !== null">
                                    ({{ curso.notas.puntaje_practico }} {{ t('puntos') }})
                                </span>
                            </div>
                            <div>
                                {{ t('Nota_final') }}:
                                {{ curso.notas && curso.notas.nota_final !== null ? curso.notas.nota_final :
                                    t('Pendiente')
                                }}
                                <span v-if="curso.notas && curso.notas.nota_final_puntos !== null">
                                    ({{ curso.notas.nota_final_puntos }} {{ t('puntos') }})
                                </span>
                            </div>
                        </template>
                        <template v-else>
                            <div>
                                {{ t('Nota_final') }}:
                                {{ curso.notas && curso.notas.nota_final !== null ? curso.notas.nota_final :
                                    t('Pendiente')
                                }}
                            </div>
                        </template>
                        <template v-if="curso.certificado && curso.notas && curso.notas.nota_final !== null">
                            <v-btn class="mt-4" color="primary" :href="`/api/certificado/${curso.id}/pdf/`"
                                target="_blank" prepend-icon="mdi-file-certificate"
                                :disabled="encuestas && encuestas.length > 0 && !encuestas[0].respondida">
                                {{ t('Descargar') }} {{ t('Certificado') }}
                            </v-btn>
                            <!-- Mensaje explicativo si el botón está deshabilitado -->
                            <p v-if="encuestas && encuestas.length > 0 && !encuestas[0].respondida"
                                class="mt-2 text-error font-italic">
                                {{ t('Para_poder_descargar_el_certificado_tienes_que_completar_la_encuesta_final_de_la_actividad') }}.
                            </p>
                        </template>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card class="mx-4">
                    <v-card-title class="text-wrap" style="word-break: break-word">{{ t('Actividad_dirigida_por') }} {{
                        curso.nombre_director }}</v-card-title>
                    <v-card-text v-if="curso.docentes" class="text-wrap" style="word-break: break-word">{{ t('Docentes')
                    }}: {{
                            curso.docentes.join(', ')
                        }}</v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card class="mx-4">
                    <CodiQR :curso="curso" :selectedOptionVista="selectedOptionVista"></CodiQR>
                </v-card>
            </v-col>
        </template>
        <template v-if="selectedOptionVista === 'docente'">
            <CodiQR :curso="curso" :selectedOptionVista="selectedOptionVista"></CodiQR>
            <ContenidoDocente></ContenidoDocente>
        </template>
    </template>

    <v-dialog v-model="showDialog" persistent>
        <v-card>
            <v-card-title>{{ t('Estás_seguro') }}</v-card-title>
            <v-card-text>
                {{ t('Estás_seguro_que_quieres_eliminar') }} el módulo "{{ moduls.modulos[pendingDeleteIndex]?.titulo
                }}"? {{
                    t('Esta_acción_eliminará_todas') }}
            </v-card-text>
            <v-card-actions>
                <v-btn color="secondary" @click="showDialog = false">{{ t('Cancelar') }}</v-btn>
                <v-btn color="error" @click="eliminarModulo">{{ t('Eliminar') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Diálogo para editar módulo -->
    <v-dialog v-model="showModuleDialog" persistent>
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Editar') }} {{ t('modulos') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="actualizarModulo" prepend-icon="mdi-content-save">
                    {{ t('Guardar') }}
                </v-btn>
                <v-btn icon @click="showModuleDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-switch v-model="moduleForm.activo" color="primary" :label="t('Activo')" append-icon="mdi-information"
                    @click:append="() => openHelpDialog('activo')"></v-switch>
                <v-text-field v-model="moduleForm.titulo" :label="t('Título')" :rules="[v => !!v || 'Campo requerido']"
                    append-icon="mdi-information" @click:append="() => openHelpDialog('titulo')"></v-text-field>
                <v-textarea v-model="moduleForm.descripcion" :label="t('Descripción')"
                    :rules="[v => !!v || 'Campo requerido']" auto-grow></v-textarea>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="showSortDialog" persistent max-width="600px">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Reordenar') }} {{ t('modulos') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="actualizarOrden" prepend-icon="mdi-content-save">
                    {{ t('Guardar') }}
                </v-btn>
                <v-btn icon @click="showSortDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-list dense>
                    <v-list-item v-for="(modulo, index) in moduls.modulos" :key="modulo.id">
                        <v-list-item-title>
                            {{ modulo.titulo }}
                        </v-list-item-title>
                        <template v-slot:append>
                            <v-btn icon="mdi-arrow-up" @click="moveModuleUp(index)"></v-btn>
                            <v-btn icon="mdi-arrow-down" @click="moveModuleDown(index)"></v-btn>
                        </template>
                    </v-list-item>
                </v-list>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="helpDialog" max-width="600px">
        <v-card>
            <v-card-title class="text-h5">{{ t('Ayuda') }}</v-card-title>
            <v-card-text>{{ helpText }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="helpDialog = false">{{ t('Cerrar') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script setup>
import { ref, reactive, watchEffect} from 'vue';
import { useI18n } from 'vue-i18n';
import MarkdownText from './MarkdownText.vue';
import ContenidoDocente from './ContenidoDocente.vue';
import CodiQR from './CodiQR.vue';
import { axios } from '../axios';


const props = defineProps({
    curso: {
        type: Object
    },
    encuestas: {
        type: Object
    },
    moduls: {
        type: Object,
        default: () => ({ modulos: [] })
    },
    moduloIndex: Number,
    selectedOption: String,
    selectedOptionVista: String,
    drawer: {
        type: Boolean,
        default: true
    },
    progresoTeorico: {
        type: Object
    }
});

const showDialog = ref(false);
const pendingDeleteIndex = ref(null);
const showModuleDialog = ref(false);
const showSortDialog = ref(false);
const snackbarText = ref('');
const helpDialog = ref(false);
const helpText = ref('');

const { t } = useI18n();
const emit = defineEmits([
    'update:drawer', 'update-modulo', 'delete-modulo', 'reorder-modules', 'triggerSnackbar', 'refrescar', 'select-leccion'
]);

const openHelpDialog = (field) => {
    helpDialog.value = true;
    switch (field) {
        case 'activo':
            helpText.value = 'Si desactivas un módulo, su contenido (lecciones, cuestionarios) no seran visibles a los alumnos, pero los podrás seguir editando y activarlos cuando quieras. Esto es útil, por ejemplo, si quieres regular el acceso al contenido a lo largo de la actividad, poner un cuestionario de evaluación final, etc...';
            break;
        case 'titulo':
            helpText.value = 'El título de tu módulo.';
            break;
        default:
            helpText.value = 'Información no disponible.';
    }
};

function openDrawer() {
    emit('update:drawer', true);
}

const moduleForm = reactive({
    id: '',
    titulo: '',
    descripcion: '',
    activo: true,
    tipo: props.selectedOptionVista,
    curso: null,
});

// Observar y reaccionar a cambios en moduls.modulos
const mod = ref([]);
watchEffect(() => {
    if (props.moduls && Array.isArray(props.moduls.modulos)) {
        mod.value = props.moduls.modulos.map(modulo => ({ ...modulo }));
    }
    if (props.curso && props.curso.id) {
        moduleForm.curso = props.curso.id;
    }
});

async function actualizarModulo() {
    try {
        const response = await axios.put(`modulos/${moduleForm.id}/`, moduleForm);
        const index = mod.value.findIndex(m => m.id === moduleForm.id);
        emit('update-modulo', { index, data: response.data });
        showModuleDialog.value = false;
        snackbarText.value = response.data.titulo + ' ' + t("fue_actualizado_con_éxito");
        emit('triggerSnackbar', { message: snackbarText.value, color: 'success' });
    } catch (error) {
        handleAxiosError(error);
    }
}

function confirmDelete(index) {
    pendingDeleteIndex.value = index;
    showDialog.value = true;
}

async function eliminarModulo() {
    const moduloId = mod.value[pendingDeleteIndex.value]?.id;
    try {
        await axios.delete(`modulos/${moduloId}/`);
        emit('delete-modulo', pendingDeleteIndex);
        showDialog.value = false;
        snackbarText.value = t("El_módulo") + ' ' + t("se_ha_eliminado_con_éxito");
        emit('triggerSnackbar', { message: snackbarText.value, color: 'success' });
    } catch (error) {
        handleAxiosError(error);
    }
}

function openModuleDialog(index) {
    moduleForm.id = mod.value[index].id;
    moduleForm.titulo = mod.value[index].titulo;
    moduleForm.descripcion = mod.value[index].descripcion;
    moduleForm.activo = mod.value[index].activo;
    showModuleDialog.value = true;
}

function moveModuleUp(index) {
    if (index > 0) {
        emit('reorder-modules', { type: 'up', index });
    }
}

function moveModuleDown(index) {

    if (index < mod.value.length - 1) {
        emit('reorder-modules', { type: 'down', index });
    }
}

async function actualizarOrden() {
    const orderedModuleIds = mod.value.map(modulo => modulo.id);
    try {
        await axios.put('modulos/reorder/', {
            curso_id: props.curso.id,
            new_order: orderedModuleIds
        });
        snackbarText.value = t("Orden_guardado_con_éxito");
        emit('triggerSnackbar', { message: snackbarText.value, color: 'success' });
    } catch (error) {
        handleAxiosError(error);
    }
    showSortDialog.value = false;
}

function handleAxiosError(error) {
    if (error.response && error.response.data && typeof error.response.data === 'object') {
        let errorMessage = Object.keys(error.response.data)
            .map(key => `${key}: ${error.response.data[key].join(' ')}`)
            .join('\n');
        snackbarText.value = errorMessage;
    } else {
        snackbarText.value = error.toString();
    }
    emit('triggerSnackbar', { message: snackbarText.value, color: 'error' });
}
</script>